import React, { FC, SVGProps } from 'react';
interface CircleExclamationProps extends SVGProps<any> {
  color: string;
}

const CircleExclamation: FC<CircleExclamationProps> = ({ color, ...props }) => (
  <svg viewBox="0 0 640 640" {...props}>
    <path
      fill={color}
      d="M320 576C178.6 576 64 461.4 64 320S178.6 64 320 64s256 114.6 256 256-114.6 256-256 256zm0-496C187.5 80 80 187.5 80 320s107.5 240 240 240 240-107.5 240-240S452.5 80 320 80zm0 368c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm2.9-255.7c6.6 1.4 11.5 7.4 11.3 14.4L328 368.3c-.2 4.3-3.7 7.7-8 7.7s-7.8-3.4-8-7.7l-6.2-161.6c-.3-8 6.1-14.7 14.2-14.7l2.9.3z"
    />
  </svg>
);

export default CircleExclamation;
